export default __webpack_public_path__ + "static/media/no-terms.cab9d73f.svg";